import React, { useState, useEffect, useRef } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import white_logo from "../../assets/newVersion/Logo.svg";
import black_logo from "../../assets/newVersion/Logo_black.svg";
import "./index.less";

const Navbar: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [isScrolled, setIsScrolled] = useState(false);
  const [activeIndex, setActiveIndex] = useState(0);
  const [indicatorPosition, setIndicatorPosition] = useState(0);
  const menuRef = useRef<HTMLUListElement>(null);

  useEffect(() => {
    const handleScroll = () => {
      const currentScroll = window.scrollY;
      setIsScrolled(currentScroll > 0);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // 监听路由变化，当路由切换时滚动到顶部
  useEffect(() => {
    // 先尝试立即滚动
    window.scrollTo(0, 0);

    // 延迟再次滚动，确保异步内容渲染完成
    const timer = setTimeout(() => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }, 16.6);

    return () => clearTimeout(timer);
  }, [location.pathname]);

  // 更新当前活动页面的索引
  useEffect(() => {
    const navItems = [
      { path: "/" },
      { path: "/smart-travel" },
      { path: "/enterprise" },
      { path: "/about" },
      { path: "/contact" },
    ];
    const currentIndex = navItems.findIndex(
      (item) => item.path === location.pathname
    );
    setActiveIndex(currentIndex >= 0 ? currentIndex : 0);
  }, [location.pathname]);

  // 更新蓝色方块位置
  useEffect(() => {
    const updateIndicatorPosition = () => {
      if (!menuRef.current) return;

      const activeElement = menuRef.current.children[
        activeIndex
      ] as HTMLElement;
      if (!activeElement) return;

      // 使用 offsetLeft 和 offsetWidth 来获取更稳定的位置
      const activeLeft = activeElement.offsetLeft;
      const activeWidth = activeElement.offsetWidth;

      // 计算相对于菜单容器的位置
      const translateX = activeLeft + activeWidth / 2 - 3; // 3px是蓝色方块宽度的一半

      setIndicatorPosition(translateX);
    };

    // 延迟执行以确保DOM已更新
    const timer = setTimeout(updateIndicatorPosition, 100);
    return () => clearTimeout(timer);
  }, [activeIndex, location.pathname]);

  const navItems = [
    { path: "/", label: "首页" },
    { path: "/smart-travel", label: "智能出行" },
    { path: "/enterprise", label: "数智企业" },
    { path: "/about", label: "关于大方" },
    { path: "/contact", label: "联系我们" },
  ];

  const handleLogoClick = () => {
    navigate("/");
  };

  return (
    <nav className={`navbar home-navbar${isScrolled ? " scrolled" : ""}`}>
      <div
        className="navbar-logo"
        onClick={handleLogoClick}
        style={{ cursor: "pointer" }}
      >
        <img src={!isScrolled ? white_logo : black_logo} alt="logo" />
      </div>
      <ul className="navbar-menu" ref={menuRef}>
        {navItems.map((item, index) => (
          <li
            key={item.path}
            className={location.pathname === item.path ? "active" : ""}
            data-index={index}
          >
            {<div className="doit"></div>}
            <Link to={item.path}>{item.label}</Link>
          </li>
        ))}
      </ul>
      <div></div>
    </nav>
  );
};

export default Navbar;
